import wrapElements from './wrap-elements';

export default function wrap(elements, rect) {
    return wrapElements(elements, rect, "x", "y", "width");
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/alignment/wrap.js
// module id = ../../../../@progress/kendo-drawing/dist/es/alignment/wrap.js
// module chunks = vendor